import {
  getShortFormVideoKPICountries,
  IProps,
} from 'url-constructors/ShortFormVideo/getShortFormVideoKPICountries';
import { getShortFormVideoTrend } from 'url-constructors/ShortFormVideo/getShortFormVideoTrendUrl';
import getByUrl from './helper/getByUrl';

interface IShortFormVideoTerritoryInterceptionData {
  entityIds: string[];
  entityType: 'artist' | 'track';
  viewType: 'views' | 'creations';
  sortBy: string;
  sortOrder: string;
  limit: number;
  offset: number;
  countryIds: string;
  searchQuery?: string;
  region?: string;
  compareMode?: string;
  platform?: number;
  customRegion?: string | string[];
}

interface IEntity {
  id: string;
  type: string;
}

export interface ICountryData {
  countryId: string;
  countryName: string;
  data: {
    count_last_last_week: number;
    count_last_week: number;
    count_rtd: number;
    metricType: number;
    rank: number;
    wow_last_completed: number;
  }[];
}
export interface ICountriesResponseData {
  countries: ICountryData[];
  entity: IEntity;
  totalCountryCount: number;
}

export interface IShortFormVideoTrendData {
  metricType: 'views' | 'creations';
  periodKey: Date;
  value: number;
}

export interface ITrendResponseData {
  countryId: string;
  data: IShortFormVideoTrendData[];
  entity: IEntity;
}

const getShortFormVideoCountriesTrendData = (
  countriesData: ICountriesResponseData[],
  options: any
): (() => Promise<ITrendResponseData[]>) => {
  const countryIds = countriesData[0].countries.map(
    (country: ICountryData) => country.countryId
  );
  const trendsUrl: string = getShortFormVideoTrend({ ...options, countryIds });
  return (): Promise<ITrendResponseData[]> =>
    getByUrl<ITrendResponseData[]>(trendsUrl);
};

const shortFormVideoTerritoryInterceptor = async (
  input: RequestInfo /* eslint-disable-line */,
  init: RequestInit | undefined /* eslint-disable-line */,
  interceptionData: IShortFormVideoTerritoryInterceptionData
): Promise<Response> => {
  const {
    entityIds,
    entityType,
    viewType,
    sortBy,
    sortOrder,
    limit,
    offset,
    countryIds,
    searchQuery,
    region,
    compareMode,
    platform,
    customRegion,
  } = interceptionData;
  const notEXCountryIds =
    (Array.isArray(countryIds) ? countryIds[0] : countryIds)?.indexOf('EX-') !==
    -1
      ? countryIds
      : '';
  const options: IProps = {
    entityIds,
    limit,
    offset,
    sortOrder,
    sortBy,
    entityType,
    countryName: searchQuery,
    metricType: viewType,
    region,
    countryIds: notEXCountryIds,
    compareMode,
    platform,
    customRegion,
  };

  const trendOptions = {
    entityIds,
    metricType: viewType,
    limit: 30,
    period: 'day',
    sfvEntityType: entityType,
    compareMode,
    platform,
    // region,
  };

  const apiUrl: string = getShortFormVideoKPICountries(options);

  try {
    const countriesData = await getByUrl<ICountriesResponseData[]>(apiUrl);
    let trendsData: ITrendResponseData[] = [];
    if (countriesData && countriesData.length) {
      trendsData = await getShortFormVideoCountriesTrendData(
        countriesData,
        trendOptions
      )();
    }

    let countriesFilterData: ICountriesResponseData[] | null = null;
    let trendFilterData: ITrendResponseData[] | null = null;
    if (countryIds) {
      const apiFilterUrl: string = getShortFormVideoKPICountries({
        ...options,
        offset: 0,
        countryIds,
        countryName: undefined,
      });

      countriesFilterData = await getByUrl<ICountriesResponseData[]>(
        apiFilterUrl
      );
      if (countriesFilterData && countriesFilterData.length) {
        trendFilterData = await getShortFormVideoCountriesTrendData(
          countriesFilterData,
          trendOptions
        )();
      }
    }

    return new Response(
      JSON.stringify({
        metricType: viewType,
        countriesData,
        trendsData,
        countriesFilterData,
        trendFilterData,
        apiUrl,
      })
    );
  } catch (error) {
    const errorInfo = await error.response.json();

    return new Response(
      JSON.stringify({
        reason: {
          error: errorInfo.message,
          errorInfo,
        },
      })
    );
  }
};

export default shortFormVideoTerritoryInterceptor;
